export default __webpack_public_path__ + "static/media/Spear of Aratus.f2ed4fb6.jpg";